import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";
// tslint:disable
export const yammer_logo: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg viewBox="0 0 256 218" preserveAspectRatio="xMidYMid" {...rest}>
      <g>
        <path
          fill={iconColor}
          stroke={iconColor}
          d="M245.767868,97.8609328 C245.231169,97.8342313 244.667768,97.828891 244.080337,97.828891
        C234.238182,97.847582 163.465986,105.609694 167.017279,112.821756 C170.555221,119.959054 214.134659,123.422232
        245.193787,123.435582 C251.703601,122.306111 256.419077,116.423781 255.970493,109.697686 C255.55128,103.793995
        251.268367,99.0758488 245.767868,97.8609328 M221.768604,172.71044 C194.527784,157.786999 154.659848,139.843624
        148.123333,144.414912 C141.541425,149.020913 199.844043,189.879473 208.468612,194.624321 C208.99463,194.910026
        209.485937,195.1717 209.958552,195.422694 C215.378947,197.00075 221.392114,194.926047 224.604298,189.940886
        C228.235696,184.266828 226.924654,176.833144 221.768604,172.71044 M221.768604,49.8704151 C226.924654,45.7477111
        228.235696,38.3140272 224.604298,32.6453091 C221.392114,27.6574781 215.378947,25.593456 209.958552,27.1661714
        C209.485937,27.4091546 208.99463,27.673499 208.468612,27.9565344 C199.844043,32.7093926 141.541425,73.5599423
        148.123333,78.1712829 C154.659848,82.7399011 194.527784,64.7991963 221.768604,49.8704151
        Z M58.4091277,159.242228
        C50.3025673,182.130712 42.7994596,192.848674 25.5610029,192.848674 C23.8948323,192.848674 18.0952772,192.506896
        17.7214569,192.472184 C12.1595447,192.186478 6.96611249,195.804525 5.4681611,201.395809 C3.74858766,207.748084
        7.47878035,214.292609 13.7963436,216.102968 C18.3649619,216.906681 23.0564068,217.203067 27.2645554,217.203067
        C59.039282,217.203067 69.5436328,198.909903 80.0346328,172.203112 L142.024721,17.5616595 C144.259633,10.5551988
        140.366561,3.06544187 133.402823,0.83587072 C126.559241,-1.34029753 119.312467,2.27774907 116.861274,8.92641033
        L73.303197,124.049716 L72.6196399,124.049716 L26.7999502,8.06128333 C23.6999118,1.50607714
        16.0312551,-1.69275668
        9.11290914,0.899954202 C2.0156635,3.56208885 -1.62908454,11.3268708 0.701952118,18.4668387
        L58.4091277,159.242228 Z"
        ></path>
      </g>
    </svg>
  );
};
